<template>
  <div class="blog-posts-page posts">
    <div class="post-list-header row pt-3  align-items-center mb-4">
      <div
        class="page-header col-12 d-flex justify-content-between align-items-center"
      >
        <div class="page-header-left d-flex align-items-center">
          <h1 class="w-full mr-2">Tags</h1>
        </div>
        <span
          class="header-right-side d-flex justify-content-center align-items-center"
        >
          <div class="input-group mr-3">
            <input
              class="form-control"
              type="text"
              v-model="newTag.tag"
              placeholder="Tag name"
            />
          </div>
          <div class="input-group mr-3">
            <input
              class="form-control"
              type="text"
              v-model="newTag.title"
              placeholder="Tag title"
            />
          </div>
          <div class="input-group mr-3">
            <input
              class="form-control"
              type="text"
              v-model="newTag.meta_description"
              placeholder="Meta description"
            />
          </div>
          <button class="btn btn-primary" @click.prevent="addTag()">
            <b>Save</b>
          </button>
        </span>
      </div>
    </div>
    <div v-if="tags && tags.length" class="row">
      <div class="col-md-4" v-for="tag in tags" :key="tag.id">
        <div class="tags-container d-flex justify-between align-items-center">
          <strong>{{ tag.title }}</strong>
          <div class="options-buttons">
            <button
              type="button"
              class="btn btn-secondary"
              @click="deleteTag(tag.id)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tags && !tags.length && !tagsLoading" class="claims">
      No tags added.
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Tags",
  data: () => ({
    tags: [],
    newTag: {
      tag: "",
      title: "",
      meta_description: ""
    },
    meta: {},
    page: 1,
    q: "",
    showFilters: false,
    tagsLoading: false
  }),
  mounted() {
    this.getTags();
  },
  methods: {
    getTags() {
      this.tagsLoading = true;
      axios
        .get("/tags")
        .then(resp => {
          this.tags = resp.data.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.tagsLoading = false;
        });
    },
    addTag() {
      axios
        .post("/tags", { ...this.newTag })
        .then(() => {
          this.getTags();
          this.keyword = "";
          this.$vToastify.success("Tag added.");
        })
        .catch(error => {
          this.$vToastify.error(error.message, "Error");
        });
    },
    deleteTag(tagId) {
      axios
        .delete(`/tags/${tagId}`)
        .then(() => {
          this.getTags();
          this.$vToastify.success("Tag deleted.");
        })
        .catch(error => {
          this.$vToastify.error(error.message, "Error");
        });
    },
    togglePost(value) {
      if (this.expanded.includes(value)) {
        const index = this.expanded.indexOf(value);
        if (index > -1) {
          this.expanded.splice(index, 1);
        }
      } else {
        this.expanded.push(value);
      }
    },
    toggleAllPosts() {
      if (!this.expanded.length) {
        this.blogPosts.forEach(post => {
          this.expanded.push(post.id);
        });
      } else {
        this.expanded = [];
      }
    },
    viewMiddle(event, id) {
      const routeData = this.$router.resolve({
        path: `/posts/${id}`
      });
      window.open(routeData.href, "_blank");
    },
    view(event, id) {
      this.$router.push(`/posts/${id}`);
    }
  }
};
</script>
<style scoped>
.tags-container {
  background-color: #fff;
  border-radius: 2px;
  margin-bottom: 10px;
  padding: 10px 30px;
}
.tags-title {
  font-weight: 600;
  font-size: 16px;
  color: #4c5669;
}
</style>
